import { submitCallForSpeakers } from '../../../utils/services';

export const UPDATE_FIELD_VALUE_CFS = 'UPDATE_FIELD_VALUE_CFS';
export const UPDATE_FORM_STATUS = 'UPDATE_FORM_STATUS';
export const SUBMIT_IN_PROGRESS = 'SUBMIT_IN_PROGRESS';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_ERROR = 'SUBMIT_ERROR';
export const RESET_FORM = 'RESET_FORM';
export const ADD_SPEAKER = 'ADD_SPEAKER';
export const UPDATE_SPEAKER = 'UPDATE_SPEAKER';
export const REMOVE_SPEAKER = 'REMOVE_SPEAKER';

const submitInProgress = () => ({
    type: SUBMIT_IN_PROGRESS,
    payload: {}
});

const submitSuccess = () => ({
    type: SUBMIT_SUCCESS,
    payload: {}
});

const submitError = () => ({
    type: SUBMIT_ERROR,
    payload: {}
});

export const updateCFSFieldValue = (fieldName, value) => ({
    type: UPDATE_FIELD_VALUE_CFS,
    payload: {
        fieldName,
        value
    }
});

export const submitCFSForm = () => async (dispatch, getState) => {
    dispatch(submitInProgress());
    try {
        await submitCallForSpeakers(getState().cfs.fields);
        dispatch(submitSuccess());
    } catch (error) {
        dispatch(submitError());
    }
};

export const updateFormStatus = (fieldName, value) => ({
    type: UPDATE_FORM_STATUS,
    payload: {
        fieldName,
        value
    }
});

export const addSpeaker = () => ({
    type: ADD_SPEAKER
});

export const removeSpeaker = id => ({
    type: REMOVE_SPEAKER,
    payload: {
        id
    }
});

export const updateSpeaker = (id, fieldName, value) => ({
    type: UPDATE_SPEAKER,
    payload: {
        id,
        fieldName,
        value
    }
});

export const resetFormAction = () => ({ type: RESET_FORM });
